// Sidebar header with Risika logo and brand text
// Created as part of ENG2-1699: Create AppLayout Component with Sidebar

import React from 'react'
import { Box, Typography } from '@mui/material'
import { tokens } from '../../styles/tokens'
import { SidebarHeaderProps } from './sidebar.types'

const SidebarHeader: React.FC<SidebarHeaderProps> = ({ isCollapsed = false }) => {
  return (
    <Box
      sx={{
        height: `${tokens.layout.topbarHeight}px`, // Match Topbar height for aligned borders
        padding: '0 20px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
      }}
    >
      {/* Logo */}
      <Box
        component="img"
        src="/risika-shield.svg"
        alt="Risika"
        sx={{
          width: 28,
          height: 36,
          flexShrink: 0,
          filter: 'brightness(0) invert(1)',
        }}
      />

      {/* Brand text */}
      {!isCollapsed && (
        <Box>
          <Typography
            sx={{
              fontFamily: '"Montserrat", sans-serif',
              fontWeight: 600,
              fontSize: '17px',
              letterSpacing: '-0.3px',
              color: '#FFFFFF',
              whiteSpace: 'nowrap',
              lineHeight: 1.2,
            }}
          >
            Risika
          </Typography>
          <Typography
            sx={{
              fontSize: '11px',
              fontWeight: 400,
              color: 'rgba(255, 255, 255, 0.5)',
              letterSpacing: 0,
              lineHeight: 1.2,
            }}
          >
            Customer Management
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default SidebarHeader
